import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-made-by',
  templateUrl: './made-by.component.html',
  styleUrls: ['./made-by.component.scss']
})
export class MadeByComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
